// ========================================
// BACKEND RESOURCES - Synced with Keycloak
// ========================================
// Total: 20 resources from backend
export const resources = {
    // Core Business Resources
    affiliates: 'Affiliates',
    business: 'Businesses',
    companies: 'Companies',
    customers: 'Customers',

    // Contract Resources
    contractsCustomers: 'Contracts Customers',
    contractsPartners: 'Contracts Partners',
    contractsSample: 'Contracts Sample',

    // Financial Resources
    invoices: 'Invoices',
    services: 'Services',

    // Document Management
    documents: 'Documents',
    drives: 'Drives',
    templates: 'Templates',

    // HR & People Resources
    employees: 'Employees',
    departments: 'Departments',
    resume: 'Resumes',
    dayoff: 'Dayoffs',
    workday: 'Workdays',

    // Customer & Marketing
    contact: 'Customer Marketing',

    // Support & Analytics
    tickets: 'Tickets',
    reports: 'Reports',

    // Other
    vcards: 'Vcards',
    tenders: 'Tenders',
    surveys: 'Surveys',

    // Resellers
    resellers: 'Resellers',
} as const

// ========================================
// BACKEND SCOPES - Synced with Keycloak
// ========================================
// Total: 29 scopes from backend
export const scopes = {
    // Basic CRUD operations
    index: 'index',
    show: 'show',
    create: 'create',
    update: 'update',
    delete: 'delete',

    // Action scopes
    active: 'active',
    approved: 'approved',
    approvedAdmin: 'approved-admin',
    cancel: 'cancel',
    closed: 'closed',
    completed: 'completed',
    convertCsFollow: 'convert-cs-follow',
    convertSaleFollow: 'convert-sale-follow',
    createPool: 'create-pool',
    download: 'download',
    driveAdmin: 'drive-admin',
    duplicate: 'duplicate',
    export: 'export',
    import: 'import',
    preview: 'preview',
    register: 'register',
    rejected: 'rejected',
    rename: 'rename',
    renew: 'renew',
    resendEmployeeToken: 'resend-employee-token',
    sendMail: 'send-mail',
    statistical: 'statistical',
    sync: 'sync',
    tech: 'tech',
}
